import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircleIcon } from "@heroicons/react/24/solid";

const Vision = () => {
    const navigate = useNavigate();

    const handleClose = () => {
      navigate(-1); // Navigate back to the previous page
    };

  return (
    <div className="bg-gray-100 min-h-screen flex justify-center items-center p-6">
          {/* Close Icon */}
      <button onClick={handleClose} className="absolute top-6 right-8 text-gray-700 hover:text-red-500 transition">
        <XCircleIcon className="w-8 h-8" />
      </button>
      <div className="bg-white shadow-lg rounded-lg max-w-3xl p-8 text-center">
        <h1 className="text-4xl font-extrabold text-blue-600 mb-4">🚀 BuildPro Vision Statement</h1>
        <h2 className="text-2xl font-semibold text-gray-800 mb-6">"Empowering Construction with Seamless Procurement."</h2>
        <p className="text-gray-700 text-lg leading-relaxed">
          BuildPro envisions a future where procuring construction materials and equipment is effortless, efficient, and transparent. Our platform connects construction professionals with a vast network of trusted suppliers and manufacturers, ensuring quick access to quality materials and equipment.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed mt-4">
          With one-click comparisons, streamlined transactions, and data-driven decision-making, BuildPro eliminates inefficiencies and accelerates project timelines, making construction procurement smarter and more reliable.
        </p>
        <p className="text-gray-700 text-lg leading-relaxed mt-4">
          We are committed to revolutionizing the industry by providing comprehensive access, quality assurance, and timely delivery—putting the power of procurement at your fingertips.
        </p>
      </div>
    </div>
  );
};

export default Vision;
